function hide(id = 'viewer0') {
  document.getElementById(`loader${id}`)?.remove()
}

export default { remove: hide }
